import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: '', name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error('Senha deve ter no mínimo 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await register({
        company_name: form.company_name.trim(),
        name: form.name.trim(),
        email: form.email.trim(),
        password: form.password,
      });
      toast.success('Conta criada! Bem-vindo.');
      navigate('/');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Falha no cadastro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--app-bg)] flex items-center justify-center p-6">
      <Card className="w-full max-w-md border-border/70">
        <CardContent className="p-6 lg:p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-9 w-9 rounded-lg bg-[hsl(var(--primary))] grid place-items-center text-white font-heading font-bold">A</div>
            <div className="font-heading font-semibold">AutoSócios</div>
          </div>
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Criar conta da empresa</h1>
          <p className="mt-1 text-sm text-muted-foreground">Você será o administrador inicial.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
            <div>
              <Label htmlFor="company_name">Nome da empresa</Label>
              <Input id="company_name" value={form.company_name} onChange={(e) => update('company_name', e.target.value)} required data-testid="register-company-input" />
            </div>
            <div>
              <Label htmlFor="name">Seu nome</Label>
              <Input id="name" value={form.name} onChange={(e) => update('name', e.target.value)} required data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" type="email" value={form.email} onChange={(e) => update('email', e.target.value)} required data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Senha (mínimo 6 caracteres)</Label>
              <Input id="password" type="password" value={form.password} onChange={(e) => update('password', e.target.value)} required data-testid="register-password-input" />
            </div>
            <Button type="submit" className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90" disabled={loading} data-testid="register-submit-button">
              {loading ? 'Criando...' : 'Criar conta'}
            </Button>
          </form>
          <div className="mt-6 text-sm text-center text-muted-foreground">
            Já tem conta?{' '}
            <Link to="/login" className="text-[hsl(var(--primary))] font-medium hover:underline" data-testid="register-login-link">
              Entrar
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
